var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { transparentize } from "polished";
import { getReadableColor } from "../../helpers";
var cardBase = {
  backgroundClip: "padding-box",
  borderStyle: "solid",
  borderRadius: "medium"
};
var cards = {
  primary: __assign(__assign({}, cardBase), {
    backgroundColor: function backgroundColor(theme) {
      return transparentize(0.5, getReadableColor(theme, "text"));
    },
    borderColor: "muted",
    borderWidth: "medium"
  }),
  callOut: __assign(__assign({}, cardBase), {
    backgroundColor: "muted",
    borderColor: "highlight",
    borderWidth: "small",
    color: function color(theme) {
      return getReadableColor(theme, "muted");
    }
  })
};
export default cards;